// extracted by mini-css-extract-plugin
export var accordion = "_b2-0";
export var chevron = "_b2-3";
export var closed = "_b2-2";
export var content = "_b2-4";
export var open = "_b2-1";
export var rotate = "_b2-5";